import { useState } from "react";
import { closeTechCalendarModal, useGlobal } from "../../core/Global";
import Modal from "../base/Modal";
import JobsCalendar from "../calendar/JobsCalendar";



export default function ModalTechCalendar() {

    const [globalState] = useGlobal()
    const [opened, openedSet] = useState<boolean>(false)


    return (
        <Modal id="modal-tech-calendar"
            title="Calendar"
            visible open size="XLarge"
            onClose={closeTechCalendarModal}
            onOpen={() => openedSet(true)}>

            {
                opened &&
                <JobsCalendar techId={globalState.techIdCalendar} />
            }

        </Modal>
    )
}